<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>الموظفين</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة موظف</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        disabled
                        v-model="mycode"
                        label="كود الموظف"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.code')"
                        data-vv-name="code"
                        data-vv-scope="form1"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.name"
                        label="أسم الموظف"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="newItem.phone" label="التليفون ">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.birthdate"
                        label="تاريخ الميلاد "
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.national_id"
                        label="الرقم القومي "
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.qualification"
                        label="المؤهلات "
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="newItem.address" label="العنوان ">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.marital_status"
                        label="الحالة الاجتماعية "
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.military_service"
                        label="موقف التجنيد "
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.exp_years"
                        label="سنين الخبرة "
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="newItem.attendance_start"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                        format="24hr"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newItem.attendance_start"
                            label="ميعاد الحضور  "
                            prepend-icon="access_time"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu1"
                          v-model="newItem.attendance_start"
                          full-width
                          @click:minute="
                            $refs.menu1.save(newItem.attendance_start)
                          "
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="newItem.attendance_end"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newItem.attendance_end"
                            label="ميعاد الانصراف  "
                            prepend-icon="access_time"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu2"
                          v-model="newItem.attendance_end"
                          full-width
                          @click:minute="
                            $refs.menu2.save(newItem.attendance_end)
                          "
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.salary"
                        label=" المرتب"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.salary')"
                        data-vv-name="salary"
                        data-vv-scope="form1"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.bonus"
                        label="الزيادة السنوية"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="newItem.target" label="التارجت ">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <!-- <v-text-field v-model="newItem.name" label="المدير المباشر" v-validate="'required'"
                        :error-messages="errors.collect('form1.name')" data-vv-name="name" data-vv-scope="form1" >
                    </v-text-field> -->
                      <v-select
                        v-model="select1"
                        :hint="
                          `${select1.job ? select1.job.name : ''}, ${
                            select1.name
                          }`
                        "
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر المدير"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select2"
                        :items="jobs"
                        item-text="name"
                        item-value="id"
                        label="أختر الوظيفة"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.job')"
                        data-vv-name="job"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select3"
                        :items="mohafzas"
                        item-text="name"
                        item-value="id"
                        label="أختر المحافظة"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.job')"
                        data-vv-name="job"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select4"
                        :items="branches"
                        item-text="name"
                        item-value="id"
                        label="أختر الفرع"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.job')"
                        data-vv-name="job"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select5"
                        :items="regions"
                        item-text="name"
                        item-value="id"
                        label="أختر المنطقة"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.job')"
                        data-vv-name="job"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-textarea
                        v-model="newItem.tasks"
                        label="المهام الوظيفية "
                      >
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل موظف</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      disabled
                      v-model="editedItem.code"
                      label="كود الموظف"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.code')"
                      data-vv-name="code"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.name"
                      label="أسم الموظف"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.phone"
                      label="التليفون "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.birthdate"
                      label="تاريخ الميلاد "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.national_id"
                      label="الرقم القومي "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.qualification"
                      label="المؤهلات "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.address"
                      label="العنوان "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.marital_status"
                      label="الحالة الاجتماعية "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.military_service"
                      label="موقف التجنيد "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.exp_years"
                      label="سنين الخبرة "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-menu
                      ref="menu3"
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editedItem.attendance_start"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="editedItem.attendance_start"
                          label="ميعاد الحضور  "
                          prepend-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="menu3"
                        v-model="editedItem.attendance_start"
                        full-width
                        @click:minute="
                          $refs.menu3.save(editedItem.attendance_start)
                        "
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-menu
                      ref="menu4"
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="editedItem.attendance_end"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="editedItem.attendance_end"
                          label="ميعاد الانصراف  "
                          prepend-icon="access_time"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="menu4"
                        v-model="editedItem.attendance_end"
                        full-width
                        @click:minute="
                          $refs.menu4.save(editedItem.attendance_end)
                        "
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.salary"
                      label=" المرتب"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.salary')"
                      data-vv-name="salary"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.bonus"
                      label=" الزيادة السنوية"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.target"
                      label="التارجت "
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <!-- <v-text-field v-model="newItem.name" label=" نوع الوظيفة" v-validate="'required'"
                        :error-messages="errors.collect('form1.name')" data-vv-name="name" data-vv-scope="form1" >
                    </v-text-field> -->
                    <v-select
                      v-model="select7"
                      :hint="
                        `${select7.job ? select1.job.name : ''}, ${
                          select7.name
                        }`
                      "
                      :items="employers"
                      item-text="name"
                      item-value="id"
                      label="أختر المدير"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <!-- <v-text-field v-model="newItem.name" label=" نوع الوظيفة" v-validate="'required'"
                        :error-messages="errors.collect('form1.name')" data-vv-name="name" data-vv-scope="form1" >
                    </v-text-field> -->
                    <v-select
                      v-model="select6"
                      :items="jobs"
                      item-text="name"
                      item-value="id"
                      label="أختر الوظيفة"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select8"
                      :items="mohafzas"
                      item-text="name"
                      item-value="id"
                      label="أختر المحافظة"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select9"
                      :items="branches"
                      item-text="name"
                      item-value="id"
                      label="أختر الفرع"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select10"
                      :items="regions"
                      item-text="name"
                      item-value="id"
                      label="أختر المنطقة"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.job')"
                      data-vv-name="job"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-checkbox
                      v-model="editedItem.status"
                      label=" تنشيط الموظف"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-textarea
                      v-model="editedItem.tasks"
                      label="المهام الوظيفية "
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="employers"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        item-key="name"
      >
        <tr slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-right">
            {{ props.item.job ? props.item.job.name : "" }}
          </td>
          <td class="text-xs-right">{{ props.item.phone }}</td>
          <td class="text-xs-right">{{ props.item.salary }}</td>
          <td class="text-xs-right">{{ props.item.bonus }}</td>
          <td class="text-xs-right">{{ props.item.target }}</td>
          <td class="text-xs-right">
            {{ props.item.status == 1 ? "فعال" : "غير فعال" }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              class="ml-4"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </tr>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>

      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  employers_page,
  add_employer,
  update_employer,
  delete_employer
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "أسم الوظيفة",
        align: "right",
        value: "name"
      },
      { text: "الوظيفة", value: "job", align: "right" },
      { text: "التليفون", value: "phone", align: "right" },
      { text: "المرتب", value: "salary", align: "right" },
      { text: "الزيادة السنوية", value: "bonus", align: "right" },
      { text: "التارجت", value: "target", align: "right" },
      { text: "حالة الموظف", value: "target", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    select1: { id: "" },
    select2: { id: "" },
    select3: { id: "" },
    select4: { id: "" },
    select5: { id: "" },
    select6: { id: "" },
    select7: { id: "" },
    select8: { id: "" },
    select9: { id: "" },
    select10: { id: "" },

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    jobs: [],
    employers: [],
    mohafzas: [],
    branches: [],
    regions: [],
    editedItem: {
      id: "",
      code: "",
      name: "",
      job: "",
      phone: "",
      salary: "",
      bonus: "",
      target: "",
      birthdate: "",
      national_id: "",
      qualification: "",
      address: "",
      marital_status: "",
      military_service: "",
      exp_years: "",
      attendance_start: "",
      attendance_end: "",
      tasks: "",
      job_id: "",
      manger_id: "",
      branch_id: "",
      mohafza_id: "",
      region_id: ""
    },
    newItem: {
      id: "",
      code: "",
      name: "",
      job: "",
      phone: "",
      salary: "",
      bonus: "",
      target: "",
      birthdate: "",
      national_id: "",
      qualification: "",
      address: "",
      marital_status: "",
      military_service: "",
      exp_years: "",
      attendance_start: "",
      attendance_end: "",
      tasks: "",
      job_id: "",
      manger_id: "",
      branch_id: "",
      mohafza_id: "",
      region_id: ""
    },
    new_code: "",
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false
  }),

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      employers_page().then(response => {
        this.employers = response.data.employers;
        this.mohafzas = response.data.mohafzas;
        this.branches = response.data.branches;
        this.regions = response.data.regions;
        this.jobs = response.data.jobs;
        this.pagination.totalItems = response.data.employers.length;
        this.loading = false;
      });
      //   this.employers=[
      //       {id:'1',code:'22',name:'محمد اشرف',job:'مشرف',phone:'2012455',salary:'2111',bonus:'100',target:'',job_id:'0',manger_id:''},
      //       {id:'2',code:'23',name:'محمود ربيع',job:'مندوب',phone:'2012455',salary:'2111',bonus:'100',target:'',job_id:'0',manger_id:''}
      //   ]
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.editedIndex = this.jobs.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.job_name = item.job_name;
      this.editedItem.phone = item.phone;
      this.editedItem.birthdate = item.birthdate;
      this.editedItem.national_id = item.national_id;
      this.editedItem.qualification = item.qualification;
      this.editedItem.address = item.address;
      this.editedItem.marital_status = item.marital_status;
      this.editedItem.military_service = item.military_service;
      this.editedItem.exp_years = item.exp_years;
      this.editedItem.attendance_start = item.attendance_start;
      this.editedItem.attendance_end = item.attendance_end;
      this.editedItem.tasks = item.tasks;
      this.editedItem.salary = item.salary;
      this.editedItem.bonus = item.bonus;
      this.editedItem.target = item.target;
      item.status == 1
        ? (this.editedItem.status = true)
        : (this.editedItem.status = false);
      this.select6 = item.job;
      item.manager
        ? (this.select7 = item.manager)
        : (this.select7 = { id: "" });
      item.branch ? (this.select9 = item.branch) : (this.select9 = { id: "" });
      item.mohafza
        ? (this.select8 = item.mohafza)
        : (this.select8 = { id: "" });
      item.region
        ? (this.select10 = item.region)
        : (this.select10 = { id: "" });
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.employers.indexOf(item);
          this.loading = true;
          var frmData2 = new FormData();
          delete_employer(frmData2, item.id).then(response => {
            this.loading = false;
            this.employers.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.newItem.code = this.code;
          this.newItem.job = this.select2.name;
          this.newItem.job_id = this.select2.id;
          this.newItem.mohafza_id = this.select3.id;
          this.newItem.branch_id = this.select4.id;
          this.newItem.region_id = this.select5.id;
          var frmData = new FormData();
          frmData.append("code", this.newItem.code);
          frmData.append("name", this.newItem.name);
          frmData.append("job_name", this.newItem.job);
          frmData.append("phone", this.newItem.phone);
          frmData.append("birthdate", this.newItem.birthdate);
          frmData.append("national_id", this.newItem.national_id);
          frmData.append("qualification", this.newItem.qualification);
          frmData.append("address", this.newItem.address);
          frmData.append("marital_status", this.newItem.marital_status);
          frmData.append("military_service", this.newItem.military_service);
          frmData.append("exp_years", this.newItem.exp_years);
          frmData.append("attendance_start", this.newItem.attendance_start);
          frmData.append("attendance_end", this.newItem.attendance_end);
          frmData.append("tasks", this.newItem.tasks);
          frmData.append("salary", this.newItem.salary);
          frmData.append("bonus", this.newItem.bonus);
          frmData.append("target", this.newItem.target);
          frmData.append("job_id", this.newItem.job_id);
          frmData.append("mohafza_id", this.newItem.mohafza_id);
          frmData.append("branch_id", this.newItem.branch_id);
          frmData.append("region_id", this.newItem.region_id);
          this.select1.id ? frmData.append("manger_id", this.select1.id) : "";
          add_employer(frmData).then(response => {
            this.employers.push(response.data);
            // this.newItem.code=''
            // this.newItem.name=''
            // this.newItem.job=''
            // this.newItem.phone=''
            // this.newItem.salary=''
            // this.newItem.bonus=''
            // this.newItem.target=''
            // this.select1={ job: '', name: 'أختر المدير' },
            // this.select2={ job: '', name: 'أختر الوظيفة' },
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
      //   if (this.editedIndex > -1) {
      //     Object.assign(this.jobs[this.editedIndex], this.editedItem)
      //   } else {
      //     this.jobs.push(this.editedItem)
      //   }

      // this.close()
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.editedItem.job_name = this.select6.name;
          this.editedItem.job_id = this.select6.id;
          this.editedItem.mohafza_id = this.select8.id;
          this.editedItem.branch_id = this.select9.id;
          this.editedItem.region_id = this.select10.id;

          this.editedItem.status == 1 || this.editedItem.status == true
            ? (this.editedItem.status = 1)
            : (this.editedItem.status = 0);

          let item_id = this.editedItem.id;
          var frmData = new FormData();
          frmData.append("code", this.editedItem.code);
          frmData.append("name", this.editedItem.name);
          frmData.append("job_name", this.editedItem.job_name);
          frmData.append("phone", this.editedItem.phone);
          frmData.append("birthdate", this.editedItem.birthdate);
          frmData.append("national_id", this.editedItem.national_id);
          frmData.append("qualification", this.editedItem.qualification);
          frmData.append("address", this.editedItem.address);
          frmData.append("marital_status", this.editedItem.marital_status);
          frmData.append("military_service", this.editedItem.military_service);
          frmData.append("exp_years", this.editedItem.exp_years);
          frmData.append("attendance_start", this.editedItem.attendance_start);
          frmData.append("attendance_end", this.editedItem.attendance_end);
          frmData.append("tasks", this.editedItem.tasks);
          frmData.append("salary", this.editedItem.salary);
          frmData.append("bonus", this.editedItem.bonus);
          frmData.append("target", this.editedItem.target);
          frmData.append("job_id", this.editedItem.job_id);
          frmData.append("mohafza_id", this.editedItem.mohafza_id);
          frmData.append("branch_id", this.editedItem.branch_id);
          frmData.append("region_id", this.editedItem.region_id);
          frmData.append("status", this.editedItem.status);
          this.select7.id ? frmData.append("manger_id", this.select7.id) : "";
          update_employer(frmData, item_id).then(response => {
            Vue.set(
              this.employers,
              this.employers.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.employers.length > 0) {
        return (this.code =
          parseInt(this.employers[this.employers.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-messages__message {
  text-align: right;
}
.v-label.theme--light {
  text-align: right;
}
.backend {
  background-color: yellow !important;
}
</style>
